export default __webpack_public_path__ + "static/media/podcard_full.c04d56fe.jpg";